import { Plus } from '@phosphor-icons/react';
import { selectCls, formatAddr } from './styles';

function AddrButtons({ targetLabel, target, selectedId, addresses, tipoMorada, onOpen }) {
  return (
    <div className="flex items-center gap-3">
      {selectedId && (
        <button type="button" data-testid={`addr-${target}-edit-btn`}
          onClick={() => {
            const addr = addresses.find((a) => String(a.ID_ClienteMorada) === String(selectedId));
            if (addr) onOpen({ mode: 'edit', tipoMorada, address: addr, target });
          }}
          className="text-xs font-medium text-[#6B7280] hover:text-[#0F1829]">Editar</button>
      )}
      <button type="button" data-testid={`addr-${target}-new-btn`}
        onClick={() => onOpen({ mode: 'new', tipoMorada, target })}
        className="text-xs font-medium text-[#002480] hover:text-[#0F1829] flex items-center gap-1">
        <Plus size={12} /> Nova morada
      </button>
      {/* targetLabel kept available for future labelling needs */}
      <span className="sr-only">{targetLabel}</span>
    </div>
  );
}

export default function AddressesSection({
  addresses, billingAddresses,
  selectedFatura, setSelectedFatura,
  selectedTransport, setSelectedTransport, transportMethods,
  selectedEnvio, setSelectedEnvio,
  onOpenEditor,
}) {
  return (
    <>
      {/* Faturação */}
      <div>
        <div className="flex items-center justify-between mb-1">
          <label className="block text-xs font-medium text-[#6B7280]">Morada de Faturação</label>
          <AddrButtons targetLabel="Faturação" target="fatura" selectedId={selectedFatura}
            addresses={addresses} tipoMorada="F" onOpen={onOpenEditor} />
        </div>
        <select data-testid="select-addr-fatura" value={selectedFatura}
          onChange={(e) => setSelectedFatura(e.target.value)} className={selectCls}>
          <option value="">Selecione morada de faturação...</option>
          {billingAddresses.map((a) => (
            <option key={a.ID_ClienteMorada} value={a.ID_ClienteMorada}>
              {formatAddr(a)}{a.Nif ? ` (NIF: ${a.Nif})` : ''}
            </option>
          ))}
        </select>
      </div>

      {/* Transporte */}
      <div>
        <label className="block text-xs font-medium text-[#6B7280] mb-1">Forma de Envio</label>
        <select data-testid="select-transport" value={selectedTransport}
          onChange={(e) => setSelectedTransport(e.target.value)} className={selectCls}>
          <option value="">Selecione forma de envio...</option>
          {transportMethods.map((m) => <option key={m.Id} value={m.Id}>{m.Descricao}</option>)}
        </select>
      </div>

      {/* Envio */}
      <div>
        <div className="flex items-center justify-between mb-1">
          <label className="block text-xs font-medium text-[#6B7280]">Morada de Envio</label>
          <AddrButtons targetLabel="Envio" target="envio" selectedId={selectedEnvio}
            addresses={addresses} tipoMorada="R" onOpen={onOpenEditor} />
        </div>
        <select data-testid="select-addr-envio" value={selectedEnvio}
          onChange={(e) => setSelectedEnvio(e.target.value)} className={selectCls}>
          <option value="">Selecione morada de envio...</option>
          {addresses.map((a) => (
            <option key={a.ID_ClienteMorada} value={a.ID_ClienteMorada}>{formatAddr(a)}</option>
          ))}
        </select>
      </div>
    </>
  );
}
